import Vue from "vue"
import Vuex from "vuex"
import AppModule from "@/store/AppModule"
import UIModule from "@/store/UIModule"
import AuthModule from "@/store/AuthModule"
import UserModule from "@/store/UserModule"
import SiteModule from "@/store/SiteModule"
import NotificationModule from "@/store/NotificationModule"
import ReportModule from "@/store/ReportModule"

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app         : AppModule.ExtractVuexModule(AppModule),
    ui          : UIModule.ExtractVuexModule(UIModule),
    auth        : AuthModule.ExtractVuexModule(AuthModule),
    user        : UserModule.ExtractVuexModule(UserModule),
    site        : SiteModule.ExtractVuexModule(SiteModule),
    notification: NotificationModule.ExtractVuexModule(NotificationModule),
    report      : ReportModule.ExtractVuexModule(ReportModule)
  }
})

export default store

export interface VXM {
  app: AppModule,
  ui: UIModule,
  auth: AuthModule,
  user: UserModule,
  site: SiteModule,
  notification: NotificationModule,
  report: ReportModule
}

export const vxm: VXM = {
  app         : AppModule.CreateProxy(store, AppModule),
  ui          : UIModule.CreateProxy(store, UIModule),
  auth        : AuthModule.CreateProxy(store, AuthModule),
  user        : UserModule.CreateProxy(store, UserModule),
  site        : SiteModule.CreateProxy(store, SiteModule),
  notification: NotificationModule.CreateProxy(store, NotificationModule),
  report      : ReportModule.CreateProxy(store, ReportModule)
}
